import { SET_DIV_CLASS } from "../actions/types";

export const divClassRedcuer = (state = null, action) => {
  switch (action.type) {
    case SET_DIV_CLASS:
      return action.payload;
    default:
      return state;
  }
};
